import React, { useState, useEffect } from 'react';
import { Heart } from 'lucide-react';

const LikeElement = ({
  element,
  isEditor = false,
  canInteract = true,
  onToggle,
  syncedLiked = null
}) => {
  const { content = {} } = element;
  const heartColor = content.heartColor || '#e11d48';
  const outlineColor = content.outlineColor || heartColor;
  const strokeWidth = content.strokeWidth ?? 2;

  const [isLiked, setIsLiked] = useState(content.isLiked || false);

  useEffect(() => {
    if (syncedLiked !== null && syncedLiked !== undefined) {
      setIsLiked(Boolean(syncedLiked));
    }
  }, [syncedLiked]);

  const handleToggle = (e) => {
    if (isEditor || !canInteract) return;
    e.stopPropagation();
    const next = !isLiked;
    setIsLiked(next);
    if (onToggle) onToggle(next);
  };

  const showFilled = isEditor ? Boolean(content.isLiked) : isLiked;

  return (
    <div
      className="w-full h-full flex items-center justify-center"
      onClick={handleToggle}
      style={{ cursor: canInteract && !isEditor ? 'pointer' : 'default' }}
    >
      <Heart
        strokeWidth={strokeWidth}
        style={{
          width: '100%',
          height: '100%',
          color: outlineColor,
          fill: showFilled ? heartColor : 'transparent',
          transition: 'fill 0.15s ease'
        }}
      />
    </div>
  );
};

export default LikeElement;
